import request from "@/utils/request";
export default {
  // RMC肉类采购量-列表查询
  findListPage: (param) => {
    return request({
      url: `/rmc/protein/purchase/findListPage`,
      method: "post",
      data: param,
    });
  },
  // RMC肉类采购量-详情维护（type:SAVE/DELETE/SUBMITTED）
  updateProteinPurchase: (param) => {
    return request({
      url: `/rmc/protein/purchase/updateProteinPurchase`,
      method: "post",
      data: param,
    });
  },
  // 批量删除
  beatchDeletePurchase: (param) => {
    return request({
      url: `/rmc/protein/purchase/beatchDeletePurchase`,
      method: "post",
      data: param,
    });
  },
  // ASL主数据分页查询
  findAsllist: (param) => {
    return request({
      url: `/rmc/protein/purchase/findAsllist`,
      method: "post",
      data: param,
    });
  },
  // 结算单位列表查询
  findSupplier: (param) => {
    return request({
      url: `/rmc/protein/purchase/findSupplier`,
      method: "post",
      data: param,
    });
  },
  // Facility列表查询
  findFacility: (param) => {
    return request({
      url: `/rmc/protein/purchase/findFacility`,
      method: "post",
      data: param,
    });
  },
  // 每个月X号，创建供应商上个月Protein采购量清单
  createLastMonthPurchase: () => {
    return request({
      url: `/rmc/protein/purchase/createLastMonthPurchase`,
      method: "get",
      data: {},
    });
  },
  // RMC肉类采购量-新增时带出Sponsor下所有的ASL及非Sponsor上个月有采购量的ASL
  getAsl: () => {
    return request({
      url: `/rmc/protein/purchase/getAsl`,
      method: "get",
      data: {},
    });
  },
  // 下拉框列表
  getSelection: (param) => {
    return request({
      url: `/downloadList`,
      method: "post",
      data: param,
    });
  },
  // RMC采购量查询列表导出
  rmcProteinPurchaseDownload: (param) => {
    return request({
      url: `/rmc/protein/purchase/rmcProteinPurchaseDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // // RMC采购量模板导出
  // rmcProteinPurchaseTempDownload: () => {
  //   return request({
  //     url: `/rmc/protein/purchase/rmcProteinPurchaseTempDownload`,
  //     method: "get",
  //     data: {},
  //   });
  // },
  // 详情列表导出
  rmcProteinPurchaseExport: (param) => {
    return request({
      url: `/rmc/protein/purchase/rmcProteinPurchaseExport`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 根据ASL获取养殖模式
  getBreedingModeByAslId: (param) => {
    return request({
      url: "/rmc/protein/purchase/breedingModeList",
      method: "get",
      params: param,
    })
  }
};
